import store from "@/store";

export const isInAvailableArea = (park) => {
  return park.Corporation.code == 'DOCOMO' && park.Region.code == 'DOCOMO_TOKYO'
};